import { type FramesInitProps } from 'frames-react';

import { checkoutElementStyles } from '../ElementStyles';

const CHECKOUT_COM_PRODUCTION_KEY = 'pk_m6yjih7mvailyyn4fmgunatoiao';
const CHECKOUT_COM_STAGING_KEY = 'pk_sbox_y67mbbuym66rphki3ktkvbjugmt';

export const getFramesConfig = ({
    billingPostcode,
    cardholderName
}: {
    billingPostcode: string;
    cardholderName: string;
}) => {
    return {
        publicKey:
            window.location.host === 'www.iwoca.co.uk'
                ? CHECKOUT_COM_PRODUCTION_KEY
                : CHECKOUT_COM_STAGING_KEY,
        cardholder: {
            name: cardholderName,
            billingAddress: { zip: billingPostcode }
        },
        localization: {
            cardNumberPlaceholder: '1234 1234 1234 1234',
            expiryMonthPlaceholder: 'MM',
            expiryYearPlaceholder: 'YY',
            cvvPlaceholder: 'CVC'
        },
        style: checkoutElementStyles
    } satisfies FramesInitProps;
};
